<template>
  <div
    class="modal nb-modal-mask"
    style="display:block; z-index: 1 !important;"
    @keyup.esc="closeModal"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-md"
      role="document"
      style="overflow-y: initial !important"
    >
      <div class="modal-content">
        <!-- <div class="modal-header" :style="headerStyle">
          <h4 class="def-title" :style="titleStyle">
            Fechamento de Caixa
          </h4>
          <button @click="closeModal" :style="titleStyle" class="close">
            <span>&times;</span>
          </button>
        </div> -->
        <div
          class="modal-body pt-3"
          style="max-height: 100%; overflow-y: auto;"
        >
          <div class="lbl mb-2" style="font-size: 20px">
            <strong>Informe a senha de administrador</strong>
          </div>
          <button @click="handleCloseButton" class="close">
            <span>&times;</span>
          </button>
          <div class="main-content">
            <div class="modal-body" style="max-height: 255px; overflow-y: auto">
              <div class="row justify-content-center">
                  <form-field ref="senha" v-model="senha" type="password" col="8" label="Digite a senha de administrador" @key.enter="handleConfirmButton()"></form-field>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="justify-content: initial">
            <button  type="button" ref="btnConfirm" class="btn btn-success btn-sm"  @click="handleConfirmButton()"> Confirmar </button>
            <button  type="button" ref="btnClose" class="btn btn-outline-secondary btn-sm" data-dismiss="modal" @click="handleCloseButton()"> Fechar </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiORDS, apiORDSpost, apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'
export default {
    props:{
        visible:{type:Boolean, required:false},
    },
    data(){
        return{
            senha: ''
        }
    },
    methods:{
        handleKeyUpEvent(event){
            let self = this;
            if (event.keyCode === 13) {
              self.handleConfirmButton();
            }
            if(event.keyCode == 27) {
              self.handleCloseButton();
            }
        },
       async handleConfirmButton(){
            
            if(!this.senha||this.senha == ''){
                this.$erpToastError('Senha obrigatoria')
                return
            }

            let obj = {}
            obj.senha = this.senha

            var modulo = 'cg/valida/adminpass/'
            const data = await apiORDSpost(this.$store, modulo, obj, 'post')
            if (!data.resultado) {
                this.$erpToastError('Senha invalida')
                return
            }

            this.visible = false
            this.$emit('confirm')
            
        },

        handleCloseButton () {
            this.visible= false
            this.$emit('close')
        }
    },
    mounted (){
      this.$refs.senha.focus()
  
      window.addEventListener('keyup',this.handleKeyUpEvent)
    },

    updated(){
      this.$refs.senha.focus()
    },

    beforeDestroy() {
      window.removeEventListener('keyup', this.handleKeyUpEvent)
    },
    
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/confirm-adminpass.vue